const TipoInscricao = Object.freeze({
  CNPJ: "CNPJ",
  CPF: "CPF",
});

export default TipoInscricao;
